import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Person } from "../../../types/person";
import usePlaceOfPersonController from "../../../controllers/connections/placeOfPersonConnectionController";
import PlaceOfPersonTable from "../../../components/tables/PlaceOfPersonConnectionTable";

interface PlaceOfPersonConnectionsSectionProps {
  person: Person;
}

const PlaceOfPersonSection: React.FC<PlaceOfPersonConnectionsSectionProps> = ({
  person,
}) => {
  const controller = usePlaceOfPersonController({from: person});
  const { openCreateDialog } = controller;
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            mb: 4,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              position: "absolute",
              left: 16,
            }}
            startIcon={<AddIcon />}
            onClick={() => openCreateDialog()}
          >
            New Place Of Person
          </Button>
          <Typography variant="h2">Places Of Person</Typography>
        </Box>
        <PlaceOfPersonTable controller={controller} />
      </Box>
    </>
  );
};

export default PlaceOfPersonSection;
